import { PropsWithChildren } from 'react';
import { Button } from '@antimatterhq/ui/components/button';

export const ExternalLink = ({
  url,
  children,
  'data-testid': dataTestId,
}: {
  url: string;
  'data-testid'?: string;
} & PropsWithChildren) => {
  return (
    <Button
      variant="link"
      leftIcon="lucide:external-link"
      iconOnly={!children}
      className="px-0"
      onClick={() => window.open(url, '_blank')}
      data-testid={dataTestId}
    >
      {children}
    </Button>
  );
};
